/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-04-18 09:43:53
 * @LastEditors: 刘洪壮 liuhongzhuang@nextmar.com
 * @LastEditTime: 2025-04-24 14:41:11
 * @FilePath: /zeelool-nextjs/src/api/customer.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { httpRequest } from '@/utils/axios';

// 删除我的信用卡
export const delMyCard = (card_id: string, data: { password: string }) =>
  httpRequest(
    `DELETE:/api/pay_center/customers/cards/{card_id}`,
    {
      card_id,
      data,
    },
    { success: false, fail: false },
  );

//

export const fetchMyCard = () => httpRequest('GET:/api/pay_center/customers/cards');

// 会员权益
export const getVipEquityData = () => httpRequest('GET:/api/customer/vip_equity');

// 信息完善角标数据记录
export const fetchClickRecord = ({ type }: { type: number }) => {
  httpRequest('POST:/api/customer/click_record', { data: { type } });
};

export const emailUs = (data: any) => httpRequest('POST:/api/customer/contact_us', { data });
